import { useRef, useState } from "react";
import { Play, Pause } from "lucide-react";
import { waLink } from "@/lib/constants";

const VIDEO_URL =
  "https://customer-assets-jai6qajn.emergentagent.net/job_guincho-24h-rp/artifacts/916b01c253b7d573_WhatsApp%20Video%202026-10-28%20at%2015.26.48.mp4";

export const VideoShowcase = () => {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(true);

  const togglePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    if (v.paused) {
      v.play();
      setPlaying(true);
    } else {
      v.pause();
      setPlaying(false);
    }
  };

  return (
    <section
      id="video"
      data-testid="video-section"
      className="section-pad bg-[#0a0a0a] relative overflow-hidden"
    >
      <div className="absolute inset-0 grid-bg opacity-20"></div>

      <div className="container-custom relative">
        <div className="max-w-3xl mb-10">
          <span className="overline">Veja em Ação</span>
          <h2 className="mt-3 font-display uppercase font-bold text-white text-4xl md:text-5xl leading-tight tracking-tight">
            Ventania na <span className="text-[#d90429]">estrada</span>
          </h2>
          <p className="mt-5 text-gray-400 text-lg">
            Frota própria, equipe treinada e operação 24h. Veja um pouco do
            nosso atendimento real em Ribeirão Preto.
          </p>
        </div>

        <div className="relative group">
          <div className="absolute -inset-2 md:-inset-3 border-2 border-[#d90429]/40 -z-10"></div>
          <div className="relative bg-black border border-[#2d3748] overflow-hidden aspect-video">
            <video
              ref={videoRef}
              data-testid="showcase-video"
              src={VIDEO_URL}
              autoPlay
              muted
              loop
              playsInline
              preload="metadata"
              className="w-full h-full object-cover"
            />
            {/* Controls */}
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <button
                  onClick={togglePlay}
                  data-testid="video-play-toggle"
                  aria-label={playing ? "Pausar vídeo" : "Reproduzir vídeo"}
                  className="bg-[#d90429] hover:bg-[#ef233c] text-white w-11 h-11 rounded-full flex items-center justify-center transition-colors"
                >
                  {playing ? (
                    <Pause className="w-5 h-5" />
                  ) : (
                    <Play className="w-5 h-5 ml-0.5" />
                  )}
                </button>
              </div>

              <a
                href={waLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="video-whatsapp-cta"
                className="hidden sm:inline-flex items-center gap-2 bg-[#25d366] hover:bg-[#1ebe56] text-white font-display uppercase tracking-wider font-bold px-5 py-3 rounded-full text-sm transition-colors"
              >
                <i className="fa-brands fa-whatsapp text-lg" aria-hidden></i>
                Chamar Agora
              </a>
            </div>
            {/* Top label */}
            <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-[#d90429] px-3 py-1.5">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
              </span>
              <span className="overline text-white text-[10px]">Ao Vivo · 24h</span>
            </div>
          </div>
        </div>

        <a
          href={waLink()}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="video-whatsapp-cta-mobile"
          className="sm:hidden btn-wa mt-6 w-full"
        >
          <i className="fa-brands fa-whatsapp text-xl" aria-hidden></i>
          Chamar no WhatsApp Agora
        </a>
      </div>
    </section>
  );
};
